import { InitialFiltersProductsState } from '../../reducers/initial-filter-products/InitialFiltersProductsReducer';
import { InitialFiltersProductsTypes } from '../Type';

export const updateInitialFiltersProducts = (payload: InitialFiltersProductsState) => {
  return (dispatch: any) => {
    dispatch({
      type: InitialFiltersProductsTypes.InitialFiltersProductsUpdate,
      payload,
    });
  };
};
